module.exports = __webpack_public_path__ + "assets/audio/c174550cc7d84611a7588b57bd23fc0f.wav";